<template>
  <v-layout fill-height>
    <v-sheet width="100%" height="100%" elevation="0">
      <v-row align="center" justify="center" fill-height>
        <v-col cols="6" v-if="!$vuetify.breakpoint.xs">
          <v-img height="100vh" :src="loginImg"></v-img>
        </v-col>
        <v-col class="d-flex flex-column justify-center align-center">
          <v-card
            max-width="360"
            elevation="0"
            class="d-flex flex-column justify-center align-center pa-5"
          >
            <v-img
              :src="logo"
              max-width="200"
              contain
              position="center center"
            />
            <label
              style="
                color: #19d3da !important;
                font-size: 10px;
                font-weight: bold;
              "
              >DEMAND MEETS SUPPLY</label
            >
            <v-card-title>
              <label class="bold-text3">Willkommen zurück</label>
            </v-card-title>
            <v-label color="#667085">Gib deine Anmeldedaten ein</v-label>
            <v-form>
              <v-row>
                <v-col class="py-0 d-flex flex-column">
                  <v-label>E-Mail</v-label>
                  <v-text-field
                    background-color="#FCFDFE"
                    dense
                    outlined
                    v-model="email"
                    required
                    full-width
                  ></v-text-field>
                  <v-label
                  >Password
                  <span style="float: right">
                    <router-link
                      class="caption my-auto"
                      style="
                        color: #9fa2b4;
                        font-style: normal;
                        text-decoration: none;
                      "
                      to="reset-password"
                      >Passwort vergessen?</router-link
                    >
                  </span>
                  </v-label>
                  <v-text-field
                  background-color="#FCFDFE"
                  style="border-radius: 8px"
                  dense
                  outlined
                  v-model="password"
                  type="password"
                  required
                  ></v-text-field>
                  <v-btn
                  @click="handleSubmit"
                  color="secondary"
                  class="align-self-center rounded-pill text-login"
                  style="width: 110px; height: 38px"
                  elevation="0"
                  rounded
                  :loading="loading"
                >
                  Login
                  </v-btn>
                </v-col>
              </v-row>

              <!--
                            <v-row class="flex justify-space-between pl-2 pt-3">
                              <router-link class="caption my-auto" to="reset-password">Passwort vergessen?</router-link>
                            </v-row> -->
            </v-form>
          </v-card>
          <v-card
            max-width="344"
            elevation="0"
            align="center"
            class="pa-5 mx-auto justify-center"
          >
            <v-card-title align="center" class="justify-center"
              ><label class="bold-text">Noch kein Account?</label>
            </v-card-title>
            <v-card-subtitle
              style="
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0.2px;
                color: #303941;
              "
              >Registriere dich
              <a style="text-decoration: none" href="/register"
                ><label class="color-text">HIER</label></a
              >
              mit wenigen Klicks auf Manushare.
            </v-card-subtitle>
          </v-card>
          <FlyInMessage
            ref="errorMessage"
            type="error"
            :message="errorMessage"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'
import router from '../../router'
import logo from '../../assets/manushare.png'
import loginImg from '../../assets/login.jpg'
import FlyInMessage from '../components/FlyInMessage.vue'

export default {
	name: 'Login',
	components: { FlyInMessage },
	data () {
		return {
			logo: logo,
			loginImg: loginImg,
			email: '',
			password: '',
			loading: false,
			errorMessage: ''
		}
	},
	methods: {
		...mapActions('auth', ['login', 'logout']),
		handleSubmit () {
			const { email, password } = this
			if (email && password) {
				this.loading = true
				const lowerCaseEmail = email.toLowerCase()
				this.login({ email: lowerCaseEmail, password })
					.then(() => {
						this.loading = false
						router.push('/dashboard')
					})
					.catch((err) => {
						this.loading = false
						if (
							typeof err.response !== 'undefined' &&
              err.response.status === 401
						) {
							this.errorMessage = 'Falsche Logindaten'
						} else if (
							typeof err.response !== 'undefined' &&
              err.response.status === 400
						) {
							this.errorMessage = 'E-Mail Adresse nicht verifiziert'
						} else {
							this.errorMessage = 'Unbekannter Fehler'
						}
						this.$refs.errorMessage.show()
					})
			}
		}
	}
}
</script>

<style scoped>
.v-btn {
  text-transform: capitalize;
  background: #fcfdfe;
  border: 1px solid #f0f1f7;
  border-radius: 8px;
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid #f0f1f7;
}

.v-text-field {
  border-radius: 8px;
  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303941;
}

.v-label {
  text-align: left;
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #303941;
}

.v-form {
  margin-top: 10%;
  width: 100%;
}

.bold-text {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #303941;
}

.color-text {
  color: #19d3da !important;
}

.bold-text3 {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #303941;
}

.text-login {
  font-family: "Karla";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
}
</style>
